import config from '../config'

export interface ReportKpi {
  collected_images: number
  quality_pass_rate: number
  quality_failed: number
  vehicles: number
  triggers: number
  anonymized_objects: number
}

export interface CollectionTrendRow {
  date: string
  count: number
  cumulative: number
}

export interface VehicleCollectionRow {
  vehicle_no: string
  count: number
  quality_failed: number
}

export interface TriggerCollectionRow {
  trigger_id: string
  trigger_label: string
  count: number
}

export interface QualityRow {
  reason: string
  count: number
}

export interface AnonymizationDailyRow {
  date: string
  total: number
  counts: Record<string, number>
}

export interface AnonymizationObjectRow {
  object_type: string
  count: number
}

export interface RawCollectionReportSummary {
  period: { start_date: string; end_date: string; date_basis?: string; date_basis_label?: string }
  kpi: ReportKpi
  collection_trend: CollectionTrendRow[]
  vehicle_collection: VehicleCollectionRow[]
  trigger_collection: TriggerCollectionRow[]
  quality_pass_count: number
  quality: QualityRow[]
  anonymization_daily: AnonymizationDailyRow[]
  anonymization_objects: AnonymizationObjectRow[]
}

class ReportService {
  private baseUrl = config.API_BASE_URL

  private getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('access_token')
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  }

  async getRawCollectionSummary(startDate: string, endDate: string): Promise<RawCollectionReportSummary> {
    const params = new URLSearchParams({ start_date: startDate, end_date: endDate })
    const resp = await fetch(`${this.baseUrl}/reports/raw-collection/summary?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    })
    if (!resp.ok) throw new Error(`리포트 조회 실패: ${resp.status}`)
    return resp.json()
  }

  async downloadRawCollectionReport(startDate: string, endDate: string): Promise<void> {
    const params = new URLSearchParams({ start_date: startDate, end_date: endDate })
    const resp = await fetch(`${this.baseUrl}/reports/raw-collection/download?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders(),
    })
    if (!resp.ok) throw new Error(`리포트 다운로드 실패: ${resp.status}`)
    const blob = await resp.blob()
    const disposition = resp.headers.get('Content-Disposition') || ''
    const match = disposition.match(/filename\*=UTF-8''([^;]+)/)
    const fallback = disposition.match(/filename="([^"]+)"/)
    const filename = match
      ? decodeURIComponent(match[1])
      : fallback
        ? fallback[1]
        : `raw_collection_report_${startDate}_${endDate}.xlsx`
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename.replace(/[\\/\0]/g, '')
    document.body.appendChild(a)
    a.click()
    a.remove()
    window.URL.revokeObjectURL(url)
  }
}

export default new ReportService()
